import { render, staticRenderFns } from "./amazonForm.vue?vue&type=template&id=997952f8&scoped=true&"
import script from "./amazonForm.vue?vue&type=script&lang=ts&"
export * from "./amazonForm.vue?vue&type=script&lang=ts&"
import style0 from "./amazonForm.vue?vue&type=style&index=0&id=997952f8&lang=scss&scoped=true&"
import style1 from "./amazonForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997952f8",
  null
  
)

export default component.exports